<template>
  <div class="footer-box">
    <!-- 导航 -->
    <div class="nav-box">
      <template v-for="(item,index) in dataList">
        <a :href="item.link" target="_blank" class="link" :key="index">{{item.name}}</a>
        <div class="line" v-if="index < dataList.length-1"></div>
      </template>
    </div>

    <!--文本-->
    <div class="desc pc_desc">英雄互娱版权所有 ©2015-2021中国网络游戏版权保护联盟举报中心 COPYRIGHT©2015 – 2026 . ALL RIGHTS RESERVED. 京ICP备15026730号-2</div>

    <div class="desc mb_desc">英雄互娱 ©yingxiong.com 津ICP备17005823号-2<br />COPYRIGHT©2015 – 2026 . ALL RIGHTS RESERVED.</div>

  </div>
</template>

<script>
import team from '../../File/views/manageCenter/team.vue'
import Link from '../components/link'
export default {
  components: { team },
  data() {
    return {
      dataList: [
        {
          name: '接入指南',
          link: Link.Confluence_join
        },
        {
          name: '关于英雄',
          link: Link.About_hero,
        },
        {
          name: '加入我们',
          link: Link.Join_us
        },
        {
          name: '隐私政策',
          link: Link.yinsi
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-box {
  width: 1005;
  height: 178px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
.nav-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  .link {
    display: block;
    font-size: 16px;
    color: #666666;
    transition: all 0.3s;
    &:hover {
      color: #3a89ff;
    }
  }
  .line {
    width: 2px;
    height: 16px;
    background: #666666;
    margin: 0 12px;
  }
}
.desc {
  margin-top: 24px;
  color: #999999;
  // line-height: 20px;
}
.pc_desc {
  display: block;
}
.mb_desc {
  display: none;
}
</style>

<style lang="scss" scoped>
.pc_desc {
  display: none;
}
.mb_desc {
  text-align: center;
  font-size: 12px;
  display: block;
}
</style>